<template>
  <el-dialog
    :visible="show"
    @update:visible="updateVisiable($event)"
    :title="lan.hint"
    width="410px"
    top="30vh"
    :show-close="true"
    class="hint_dialog"
  >
    <div class="wait_hint">
      {{lan.youLine}}<span style="color: #f4a100;font-size: 20px;padding: 0 10px">{{waitData.broadcast_name}}</span>{{lan.anEnter}}
    </div>
    <div class="wait_btn">
      <el-button
        @click="handleJoin"
        style="width: 120px;height: 40px;background-color: #f4a100;font-size: 14px;border: none;color: #ffffff"
      >{{lan.into}}<span class="wait_time">{{time}}s</span>
      </el-button>
      <el-button
        @click="handleNotJoin"
        style="width: 120px;height: 40px;background-color: #cccccc;font-size: 14px;border: none;color: #ffffff"
      >{{lan.notEnter}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {getDialogJoin, getNotEnter} from "../../api/webSocket";
  import {language} from "../../language/get";
  import {getLiveUrl} from "../../api/forum";
  import {mapGetters} from "vuex"
  import {roomUrl, windowsGoTo} from "../../common/url";
  import Cookie from "../../common/cookie";
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      waitData: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      ...mapGetters(["token", "userInfo"])
    },
    data() {
      return {
        lan: language(),
        lang: Cookie.get("lang"),
        time: 30,
        timer: null
      }
    },
    methods: {
      updateVisiable(v) {
        this.$emit("update:show", v);
      },
      handleJoin() {
        const alterProps = {token: this.token,roomid:this.waitData.roomid,type:1};
        const props ={token: this.token,broadcast_id:this.waitData.roomid};
          getLiveUrl(props).then(res => {
            if (res.data[0].type != '1') {
              if (this.lang == "ch") {
                this.$message.error({message: res.text, offset: 120})
              }else {
                this.$message.error({message: res.text_en, offset: 120})
              }
              this.updateVisiable(false);
              return;
            }
            const data = res.data[0];
            getDialogJoin(alterProps).then(res => {
              if (res.type == 1) {
                return window.location.href = windowsGoTo() + roomUrl(data, this.userInfo.true_name)
              }
            })
          })
      },
      handleNotJoin() {
        const props ={token: this.token,roomid:this.waitData.roomid,type:2};
        getNotEnter(props).then(() => {});
        clearInterval(this.timer);
        this.time = 30;
        this.timer = null;
        this.updateVisiable(false);
      }
    },
    watch: {
      show: {
        handler() {
          if (this.show == true) {
            clearInterval(this.timer);
            this.time = 30;
            this.timer = null;
            const props ={token: this.token,roomid:this.waitData.roomid,type:2};
            if (!this.timer){
              this.timer = setInterval(() => {
                if (this.time == 0) {
                  clearInterval(this.timer);
                  getNotEnter(props).then(() => {});
                  this.updateVisiable(false);
                  this.time = 30;
                  this.timer = null;
                }
                this.time--;
              },1000)
            }
          }
          if (this.show == false) {
            clearInterval(this.timer)
            this.time = 30;
            this.timer = null;
            this.updateVisiable(false);
          }
        },
        immediate: true,
        deep: true
      }
    }
  }
</script>

<style scoped>
  .wait_hint {
    text-align: center;
    color: #424242;
    font-size: 18px;
    margin-top: 35px;
  }
  .wait_btn {
    text-align: center;
    margin-top: 40px;
  }
  .el-button+.el-button {
    margin-left: 40px !important;
  }
  .el-message-box__title {
    padding-bottom: 10px !important;
    border-bottom: 1px solid #a1a1a1 !important;
  }
  .wait_time{
    color: #eb0d0d;
    font-size: 14px;
  }
</style>
